import { useEffect, useRef } from 'react';

/**
 * Custom hook for detecting clicks outside an element
 * @param {Function} handler - Function to call when clicking outside
 * @returns {Object} Ref to attach to the element
 */
const useClickOutside = (handler) => {
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handler]);

  return ref;
};

export default useClickOutside;